/* eslint-disable react/no-unused-state */
import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, ToggleSwitch } from '@gcc/autobahn-components';
import config from '../../helpers/config';
import DownloadIcon from '../../themes/svg/downloadIcon';
import { sites } from '../../helpers/globalVariables';

const PrintCommercialEstimate = ({ designId, hasProducts, repId }) => {
  const [openModal, setOpenModal] = useState(false);
  const [toggleDimensions, setToggleDimensions] = useState(true);
  const [togglePricing, setTogglePricing] = useState(true);

  const getEstimatePrintUrl = () => {
    if (config.siteId === sites.blinds) {
      return `/api/myaccount/estimates/${designId}/${new Date().getTimezoneOffset()}/commercial/print/?dimensions=${toggleDimensions}&pricing=${togglePricing}&repId=${repId}&isCommercial=true`;
    }
    return `${
      config.designBuilderApiBaseUrl
    }/estimates/${designId}/${new Date().getTimezoneOffset()}/commercial/print/?dimensions=${toggleDimensions}&pricing=${togglePricing}&repId=ddalton&isCommercial=true`;
  };

  const handleOpenModal = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <Fragment>
      {hasProducts && (
        <div className="action downloadEstimate">
          <button className="flex bg-transparent bn" onClick={e => handleOpenModal(e)}>
            <DownloadIcon />
            <span id="downloadEstimateButton" className="actionText link nowrap tl">
              Download Commercial
            </span>
          </button>
        </div>
      )}
      <Modal
        height={300}
        isOpen={openModal}
        onClose={handleCloseModal}
        title="Commercial PDF Controls"
        width={450}
        theme={{
          modal: {
            settings: {
              footer: false,
            },
            closeButton: 'black pr3',
            borderRadius: 'br2',
            overlayColorRgba: 'rgba(0,0,0,.8)',
            hasTitle: 'pa3',
            header: {
              appearance: 'pv3 pl3 bb b--gray bw1',
            },
          },
        }}
      >
        <div className="pa3">
          <div className="pb3">
            <p>Flip the toggles off to hide columns in the Estimate PDF</p>
          </div>
          <div className="gcc-toggle-container">
            <div className="flex items-center mb2">
              <ToggleSwitch
                id="switch-dimensions"
                checked={togglePricing}
                onChange={() => setToggleDimensions(!toggleDimensions)}
                label="Dimensions"
              />
            </div>
            <div className="flex items-center">
              <ToggleSwitch
                id="switch-pricing"
                checked={togglePricing}
                onChange={() => setTogglePricing(!togglePricing)}
                label="Line-item Pricing"
              />
            </div>
          </div>
          <div className="flex w-100 h-50 items-end justify-end pb2">
            <a className="gcc-btn bg-dark-orange white" href={getEstimatePrintUrl()} target={designId}>
              Create & Download
            </a>
          </div>
        </div>
      </Modal>
    </Fragment>
  );
};

PrintCommercialEstimate.propTypes = {
  designId: PropTypes.string.isRequired,
  hasProducts: PropTypes.bool.isRequired,
  repId: PropTypes.string.isRequired,
};

export default PrintCommercialEstimate;
